import { ITask } from '../../TInvoker';

export default function aggregateError(tasks: ReadonlyArray<ITask>): unknown {
    const errors = tasks
        .map((item) => item.result?.error)
        .filter((result) => typeof result !== 'undefined');
    return new AggregateError(errors, 'No Task in Invoker was resolved');
}
